import { render } from "./TimesheetPendingActions.vue?vue&type=template&id=86a12b3e&scoped=true"
import script from "./TimesheetPendingActions.vue?vue&type=script&lang=js"
export * from "./TimesheetPendingActions.vue?vue&type=script&lang=js"

import "./TimesheetPendingActions.vue?vue&type=style&index=0&id=86a12b3e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a12b3e"]])

export default __exports__